const KEYCLOAK_BASE_URL = import.meta.env.VITE_KEYCLOAK_BASE_URL || 'https://quantumhusky.ai/keycloak'
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'QuantumHusky'
const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'quantumhusky-web-cli'

export const KEYCLOAK_CONFIG = {
  url: KEYCLOAK_BASE_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
}

const realmPath = `${KEYCLOAK_CONFIG.url}/realms/${KEYCLOAK_CONFIG.realm}`

export const KEYCLOAK_ENDPOINTS = {
  authorization: `${realmPath}/protocol/openid-connect/auth`,
  token: `${realmPath}/protocol/openid-connect/token`,
  userInfo: `${realmPath}/protocol/openid-connect/userinfo`,
  logout: `${realmPath}/protocol/openid-connect/logout`,
}

export const REDIRECT_URI = `${window.location.origin}/callback`
export const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/logged-out`
